import React from 'react'
import ModalOverlay from '../../../UI/ModalOverlay/ModalOverlay.tsx'
import styles from './DocumentInsightProceedWarnModal.module.scss'

export type DocumentInsightProceedWarnModalMode = 'retryPipeline' | 'dismissInsightBanner'

type Props = {
  open: boolean
  mode: DocumentInsightProceedWarnModalMode
  onCancel: () => void
  onConfirm: () => void
  busy?: boolean
}

const DocumentInsightProceedWarnModal: React.FC<Props> = ({
  open,
  mode,
  onCancel,
  onConfirm,
  busy = false
}) => {
  const isRetry = mode === 'retryPipeline'
  return (
    <ModalOverlay isOpen={open} onClose={onCancel} zIndex={30}>
      <div
        className={styles.box}
        role="dialog"
        aria-modal="true"
        aria-labelledby="doc-insight-warn-title"
      >
        <h2 id="doc-insight-warn-title" className={styles.title}>
          {isRetry ? 'Reintentar análisis' : 'Aviso'}
        </h2>
        <p className={styles.body}>
          {isRetry
            ? 'Aunque el modelo puede equivocarse, con un archivo poco relacionado es muy probable que el borrador no se cree bien. Vamos a reenviar el mismo archivo y mensaje al análisis.'
            : 'El modelo puede equivocarse y el borrador puede quedar incompleto o poco fiable. Podés cambiar la documentación desde el enlace del asistente cuando corresponda.'}
        </p>
        <div className={styles.actions}>
          <button type="button" className={styles.secondary} onClick={onCancel} disabled={busy}>
            Cancelar
          </button>
          <button type="button" className={styles.primary} onClick={onConfirm} disabled={busy}>
            {isRetry ? 'Sí, reintentar' : 'Ocultar aviso'}
          </button>
        </div>
      </div>
    </ModalOverlay>
  )
}

export default DocumentInsightProceedWarnModal
